import { render, staticRenderFns } from "./AutoReportTag.vue?vue&type=template&id=0ecbeaa4&scoped=true"
import script from "./AutoReportTag.vue?vue&type=script&lang=js"
export * from "./AutoReportTag.vue?vue&type=script&lang=js"
import style0 from "./AutoReportTag.vue?vue&type=style&index=0&id=0ecbeaa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecbeaa4",
  null
  
)

export default component.exports